import { useQuotaWarning } from "@Src/contexts/QuotaWarningContext";
import { WarningAmber } from "@mui/icons-material";
import { Box, Fade, Typography } from "@mui/material";

export const QuotaNotificationBanner = () => {
	const { showFormsWarning, showApplicationsWarning, quotaData, isLoading } =
		useQuotaWarning();

	// Don't render anything if loading or no warnings
	const showWarning =
		!isLoading && (showFormsWarning || showApplicationsWarning);

	if (!showWarning) {
		return null;
	}

	// Build the warning message
	let message = "";
	if (showFormsWarning && showApplicationsWarning) {
		// Combine both warnings
		message = `You have ${quotaData?.remaining_forms} form${quotaData?.remaining_forms === 1 ? "" : "s"} and ${quotaData?.remaining_applications} response${quotaData?.remaining_applications === 1 ? "" : "s"} remaining. You can upgrade here!`;
	} else if (showFormsWarning) {
		message = `You have ${quotaData?.remaining_forms} form${quotaData?.remaining_forms === 1 ? "" : "s"} remaining. You can upgrade here!`;
	} else if (showApplicationsWarning) {
		message = `You have ${quotaData?.remaining_applications} response${quotaData?.remaining_applications === 1 ? "" : "s"} remaining this month. You can upgrade here!`;
	}

	return (
		<Fade in={showWarning}>
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					gap: 1,
					px: 2,
					py: 0.5,
					backgroundColor: "warning.light",
					color: "warning.contrastText",
					borderRadius: 1,
					maxWidth: "600px",
					transition: "all 0.3s ease-in-out",
				}}
			>
				<WarningAmber fontSize="small" />
				<Typography variant="body2" sx={{ fontWeight: 500 }}>
					{message}
				</Typography>
			</Box>
		</Fade>
	);
};
